"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isObject = _interopRequireDefault(require("./isObject"));

var isEmpty = function isEmpty(obj) {
  return !(0, _isObject["default"])(obj) || !Object.keys(obj).length;
};

var _default = isEmpty;
exports["default"] = _default;